var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.result.hasErrors)?_c('Success',{attrs:{"processID":_vm.result.processID}}):_vm._e(),(_vm.result.hasErrors)?_c('Failure',{attrs:{"errorMessage":_vm.result.errorMessage}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }